import { motion } from "framer-motion";

// The Field — a cinematic, living representation of presence.
// intensity 0..1 controls warmth, size, brightness, coherence.
export default function TheField({ intensity = 0.5, active = true, size = 320, children }) {
  const scale = 0.72 + intensity * 0.55;
  const opacity = 0.35 + intensity * 0.55;

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      {/* slow rotating shimmer ring — teal → blue → coral */}
      <motion.div
        className="absolute rounded-full"
        style={{
          width: size, height: size,
          background: `conic-gradient(from 0deg, hsl(175 75% 55% / ${opacity * 0.6}), transparent 25%, hsl(210 100% 60% / ${opacity * 0.5}) 52%, transparent 78%, hsl(12 90% 62% / ${opacity * 0.6}))`,
          filter: "blur(30px)",
        }}
        animate={active ? { rotate: 360 } : {}}
        transition={{ duration: 26, repeat: active ? Infinity : 0, ease: "linear" }}
      />
      {/* breathing core — luminous aqua/blue */}
      <motion.div
        className="absolute rounded-full"
        style={{
          width: size, height: size,
          background: `radial-gradient(circle at 50% 46%, hsl(190 95% 62% / ${opacity}) 0%, hsl(210 100% 58% / ${opacity * 0.6}) 34%, hsl(175 70% 50% / 0) 68%)`,
          filter: "blur(38px)",
        }}
        animate={active ? { scale: [scale, scale * 1.09, scale], opacity: [opacity, opacity * 1.18, opacity] } : { scale }}
        transition={{ duration: 6.5, repeat: active ? Infinity : 0, ease: "easeInOut" }}
      />
      {/* inner light — the person */}
      <motion.div
        className="absolute rounded-full"
        style={{
          width: size * 0.5, height: size * 0.5,
          background: `radial-gradient(circle, hsl(0 0% 100% / ${0.4 + intensity * 0.4}) 0%, hsl(190 90% 75% / 0) 70%)`,
          filter: "blur(16px)",
        }}
        animate={active ? { scale: [1, 1.14, 1] } : {}}
        transition={{ duration: 4.6, repeat: active ? Infinity : 0, ease: "easeInOut" }}
      />
      {/* fine ring outline for coherence */}
      <div className="absolute rounded-full" style={{ width: size * 0.62, height: size * 0.62, border: `1px solid hsl(190 80% 70% / ${0.1 + intensity * 0.15})` }} />
      <div className="relative z-10 flex items-center justify-center text-center">{children}</div>
    </div>
  );
}
